<template>
  <div class="mask noticemask" v-show="clickis">
     <div class="applogin noticeapplogin" >
       <div class="notice_title">{{title&& title!=''? title : $t('game.notice') }}</div>
       <div class="notice_content">{{ content }}</div>
       <div class="notice_btn ok_btn" v-if="success && success=='notice'">
         <span class="notice_confirm" @click="confirm()">{{oktext && oktext!=""? oktext : $t('game.okbtn') }}</span>
       </div>
       <div class="notice_btn ok_btn" v-else-if="oktext && oktext!='' && !canceltext" >
         <span class="notice_confirm" @click="confirm()">{{ oktext }}</span>
       </div>
       <div class="notice_btn" v-else>
         <span class="notice_cancel" @click="cancelbtn()">{{ canceltext && canceltext!=""? canceltext : $t('game.orderCancel') }}</span>
         <span class="notice_confirm" @click="confirm()">{{ oktext && oktext!=""? oktext : $t('game.confirm') }}</span>
       </div>
     </div>
  </div>
</template>

<script>
  export default {
    props: ['content','success','cancel','oktext','canceltext','title'],
    data() {
       return {
          clickis:false
       }
    },
    methods:{
      open(){
        this.clickis = true;
      },
      close(){
        this.clickis = false;
      },
      cancelbtn(){
        this.clickis = false;
        if(this.cancel){
          this.cancel()
        }
      },
      confirm(){
        this.clickis = false;
        if(typeof this.success === 'function'){
          this.success();
        }

      }
    }
  }
</script>

<style scoped>
  .noticemask{
    display: flex;
    justify-content: center;
    user-select: none;
    align-items: center;
  }
  .notice_title{
    text-align: center;
    font-family: Inter;
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 2.5rem;
    font-family: "Regular";
    margin-top: 0.6rem;
  }
  .notice_content{
    font-family: "Regular";
    font-size: 0.9375rem;
    font-weight: 200;
    line-height: 1.45rem;
    text-align: center;
    padding:1.05rem 0.6rem 1.25rem;
    color: rgba(135, 141, 150, 0.8);
  }
  .notice_btn{
    display: flex;
    justify-content: space-between;
    padding:0.4rem 0.9375rem 1.25rem;
  }
  .ok_btn{
    justify-content: center;
  }
  .notice_btn span{
    width: 45%;
    display: block;
    height: 2.5rem;
    line-height:2.5rem;
    text-align: center;
    border-radius: 0.375rem;
    color: rgba(7, 194, 97, 1);
    border: 1px solid rgba(7, 194, 97, 1);
  }
  .notice_btn .notice_confirm{
    background-color: rgba(7, 194, 97, 1);
    color: #fff;
  }
  .noticeapplogin{
    width: 84%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/notice.vue